import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useState } from "react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Sidebar } from "@/components/Sidebar";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import TicketList from "@/pages/TicketList";
import NewTicket from "@/pages/NewTicket";
import TicketDetail from "@/pages/TicketDetail";
import Analytics from "@/pages/Analytics";
import DataMigration from "@/pages/DataMigration";
import CustomerTracking from "@/pages/CustomerTracking";
import "@/App.css";

function ProtectedLayout() {
  const { user, loading } = useAuth();

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    return localStorage.getItem("xp-sidebar") !== "closed";
  });

  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      localStorage.setItem("xp-sidebar", prev ? "closed" : "open");
      return !prev;
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-lime-600" />
          <p className="text-sm text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar open={sidebarOpen} onToggle={toggleSidebar} />
      <main className="flex-1 overflow-auto min-w-0">
        <Outlet />
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/track" element={<CustomerTracking />} />
          <Route path="/track/:id" element={<CustomerTracking />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tickets" element={<TicketList />} />
            <Route path="/tickets/new" element={<NewTicket />} />
            <Route path="/tickets/:id" element={<TicketDetail />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/data-migration" element={<DataMigration />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
